import React from 'react';

// A quiet version of the original dice-pattern section bands.
export default function SectionBar({ children, tone = 'paper', className = '' }) {
  return <div className={`flex min-h-[64px] flex-wrap items-center justify-between gap-x-3 gap-y-2 rounded-xl px-3 py-3 sm:px-5 sm:py-4 ${className}`}
    style={{
      '--section-surface': tone === 'dark' ? '31 46 61' : tone === 'white' ? '255 255 255' : '244 244 244',
      backgroundColor: 'rgb(var(--section-surface))',
      backgroundImage: tone === 'dark' ? 'none' : "linear-gradient(90deg, rgb(var(--section-surface)) 0%, rgb(var(--section-surface) / .86) 40%, rgb(var(--section-surface) / .55) 100%), url('/img/featured-bg.jpg')",
      backgroundSize: 'auto, auto 140px',
      backgroundPosition: 'center, right center',
    }}>
    {children}
  </div>;
}
